import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

export const apiCopyHandler = (payload) => {
  const serviceURL = constructServiceURL({
    endpoint: 'copyHandlersOfMrdDefault',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      sourceMrdName: payload.sourceMrdName,
    },
  });
  return axios.post(serviceURL, payload.targetMrdName, { headers: { 'Content-Type': 'text/plain' } });
};
